import React from 'react';

import PropTypes from 'prop-types';

const PageForward = ({ onClick, onKeyDown }) => (
    <a
        id="page-forward"
        type="button"
        className="ml-pagination-numbers pg-next"
        title="Next Page"
        aria-label="Next Page"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={onKeyDown}
    >
        <span className="d-none">Next Page </span>
        <span>...</span>
    </a>
);

PageForward.propTypes = {
    onClick: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
};

export default PageForward;

